function SupportedMetaverseListItem(props) {
    return (
        <li key="">
            <a href={props.metaverseHomepageURL}>
                <img className="h-10 grayscale opacity-70 transition-all hover:opacity-100 hover:grayscale-0" src={props.imgSrc} alt={props.name} />
            </a>
        </li>
    );
}

export default SupportedMetaverseListItem;